import React from 'react';

const Footer = () => (
  <footer className="bg-gray-100 text-gray-600 text-center p-4 mt-8 text-sm">
    <div className="container mx-auto">
      © {new Date().getFullYear()} Benefits Value Analysis Tool. All rights reserved.
      {/* You can add more footer links or information here */}
    </div>
  </footer>
);

export default Footer;
